import posthog from "posthog-js";

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;

// PostHog system events that should NOT trigger session recording.
// Recording starts only on intentional events: $autocapture (gated by the
// css_selector_allowlist below to data-ph-tagged elements) and custom events
// from posthog.capture() / the analytics track() wrapper.
const RECORDING_TRIGGER_SKIP_EVENTS = new Set([
  "$pageview",
  "$pageleave",
  "$exception",
  "$heatmap",
  "$rageclick",
  "$web_vitals",
  "$identify",
  "$set",
  "$set_once",
  "$groupidentify",
  "$opt_in",
  "$create_alias",
  "$snapshot",
  "$session_recording_started",
]);

if (posthogKey) {
  try {
    posthog.init(posthogKey, {
      autocapture: {
        css_selector_allowlist: [
          "[data-ph-capture-attribute]",
          "[data-ph-capture-attribute-event-name]",
        ], // Only capture elements explicitly tagged
      },
      api_host: `/focal-jb9w32f9hx`,
      ui_host: "https://us.posthog.com",
      person_profiles: "identified_only", // Only create Person profiles after identify() is called
      capture_pageview: "history_change",
      capture_pageleave: true, // Enable pageleave capture
      capture_exceptions: true, // This enables capturing exceptions using Error Tracking
      capture_heatmaps: true,
      disable_session_recording: true, // Off by default; started below on intentional events
      debug: false,
      before_send: (event) => {
        if (event && !RECORDING_TRIGGER_SKIP_EVENTS.has(event.event)) {
          posthog.startSessionRecording();
        }
        return event;
      },
    });
    posthog.register({ source: "app" });
  } catch (error) {}
} else {
  console.warn("PostHog key not found. Analytics will be disabled.");
}
